export const listInfiniteScroll = (handlePageScroll: () => void, elem: HTMLDivElement) => {
  const handleIntersect: IntersectionObserverCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        handlePageScroll();
      }
    });
  };

  const observer = new IntersectionObserver(handleIntersect, {});
  observer.observe(elem);

  return {
    remove: () => observer?.disconnect(),
  };
};
